import React from "react";
import ReactDOM from "react-dom";
import ColorwaySlider from "./src/Components/ColorwaySlider.js"
import ShoeImageSwiper from "./src/Components/ShoeImageSwiper.js"
import ErrorBoundary from './src/Components/ErrorBoundary.js';
import PriceComparison from './src/Components/PriceComparison.js';

import "core-js/features/object";

//import "./src/css/swiper.css"

import 'swiper/swiper.scss';

//import './src/css/lazy.scss';
import './src/css/pagination.scss';
import './src/css/navigation.scss';

import "./src/css/custom_bootstrap.scss";
//import "./src/css/featherlight.css";
import "./src/css/StyleModal.css";
import './src/css/additional_swiper.css';

import SwiperCore, {Lazy,Pagination,Navigation} from 'swiper';

SwiperCore.use([Lazy,Pagination,Navigation]);

import BuyButtonV2 from "./src/Components/BuyButtonV2.js"
import LazyLoad from 'react-lazyload';

function App(props){
  return(
    <div>
      <LazyLoad offset={800}>
        <ColorwaySlider linkId={props.linkId} type={props.type} shoe={window.shoes[props.shoe_number]}/>
      </LazyLoad>
    </div>
  );
}

let swiperContainerList=document.getElementsByClassName("comparison_swiper");
for (let i = 0; i < swiperContainerList.length; i++) {
  let currentContainer=swiperContainerList[i];
  let shoe_number=currentContainer.getAttribute("data_shoe_number");
  let type=currentContainer.getAttribute("data_shoe_type");
  let tracking_id=currentContainer.getAttribute("data_shoe_tracking_id");
  ReactDOM.render(
    <ErrorBoundary>
      <App linkId={tracking_id + "_" + type} type={type} shoe_number={shoe_number}/>
    </ErrorBoundary>
    ,currentContainer
  )
}



let containerButtonList=document.getElementsByClassName("popup_button");

let lastUpdate=window.last_update;

for (let i = 0; i < containerButtonList.length; i++) {
  let currentContainer=containerButtonList[i];
  let shoe_number=currentContainer.getAttribute("data_shoe_number");
  let button_color=currentContainer.getAttribute("data_button_color");
  let type=currentContainer.getAttribute("data_shoe_type");
  let tracking_id=currentContainer.getAttribute("data_shoe_tracking_id");
  let button_nr=currentContainer.getAttribute("button_nr");
  let showDiscount=currentContainer.getAttribute("data_shoe_discount") ==="true";

  if(type==="tablev2" || type==="tablev3"){
    ReactDOM.render(
      <ErrorBoundary>
        <BuyButtonV2 style={{fontSize:16,padding:"0.5rem 1.2rem",boxShadow:"none"}} showDiscount={showDiscount} button_nr={button_nr} buttonColor={button_color} lastUpdate={lastUpdate} prefix={tracking_id +"_" + type} shoe={window.shoes[shoe_number]}/>
      </ErrorBoundary>
        ,currentContainer
    );
  }

  else if(type==="textv4"){
    ReactDOM.render(
      <ErrorBoundary>
        <BuyButtonV2 style={{fontSize:18}} showDiscount={showDiscount} button_nr={button_nr} buttonColor={button_color} lastUpdate={lastUpdate} prefix={tracking_id +"_" + type} shoe={window.shoes[shoe_number]}/>
      </ErrorBoundary>
        ,currentContainer
    );
  }

  else if(type==="textv5"){
    ReactDOM.render(
      <ErrorBoundary>
        <PriceComparison prefix={tracking_id +"_" + type} shoe={window.shoes[shoe_number]}/>
      </ErrorBoundary>
        ,currentContainer
    );
  }


  else{
    ReactDOM.render(
      <ErrorBoundary>
        <BuyButtonV2 style={{fontSize:16,padding:"0.5rem 1.2rem",boxShadow:"none"}} showDiscount={showDiscount} button_nr={button_nr} buttonColor={button_color} lastUpdate={lastUpdate} prefix={tracking_id +"_" + type} shoe={window.shoes[shoe_number]}/>
      </ErrorBoundary>
        ,currentContainer
    );
  }
}



let ShoeImageSwiperList=document.getElementsByClassName("shoe_image_swiper");
for (let i = 0; i < ShoeImageSwiperList.length; i++) {
  let currentContainer=ShoeImageSwiperList[i];
  let shoe_number=currentContainer.getAttribute("data_shoe_number");
  ReactDOM.render(
    <ErrorBoundary>
      <ShoeImageSwiper pictures={window.shoes[shoe_number].pictures}/>
    </ErrorBoundary>
    ,currentContainer
  )
}
